export const AustinTx = {
  lat: 30.26715,
  lng: -97.74306,
};
